import React from "react";

import Banner from "../../../sections/Banner/Banner";
import ContentBlock from "../../../sections/ContentBlock/ContentBlock";

const dmvMeet = () => {
  return (
    <div>
      <Banner
        img_src="https://districttrack.s3.us-east-2.amazonaws.com/v2/photos/running/dmv-meet-1.JPG"
        img_alt="DMV Meet of Champions 2018 boys mile"
      >
        <h1>DMV Meet of Champions</h1>
        <h4>Returning in 2022</h4>
      </Banner>
      <section className="black">
        <h2>DC. Maryland. Virginia.</h2>
        <h3 className="subheader">
          The DMV Meet of Champions assembles the best high school runners from
          the DMV. These runners battle it out to see who really is the
          District's fastest.
        </h3>
      </section>
      <section>
        <h2>Meet Records</h2>
        <ContentBlock>
          <div>
            <h3>Girls 400m</h3>
            <h4>
              <span className="b">55.06</span> - Ziyah Holman, DC, 2019
            </h4>
            <br />
            <h3>Girls 800m</h3>
            <h4>
              <span className="b">2:11.56</span> - Alahna Sabbakhan, DC, 2018
            </h4>
            <br />
            <h3>Girls 1600m</h3>
            <h4>
              <span className="b">4:55.95</span> - Ellie Desmond, VA, 2019
            </h4>
          </div>
          <div>
            <h3>Boys 400m</h3>
            <h4>
              <span className="b">48.69</span> - Dante Jackson, VA, 2019
            </h4>
            <br />
            <h3>Boys 800m</h3>
            <h4>
              <span className="b">1:52.19</span> - Sam Affolder, VA, 2019
            </h4>
            <br />
            <h3>Boys 1600m</h3>
            <h4>
              <span className="b">4:08.69</span> - Sam Affolder, VA, 2018
            </h4>
            <br />
            <h3>Boys 3200m</h3>
            <h4>
              <span className="b">9:12.18</span> - Kellen Hasle, VA, 2019
            </h4>
          </div>
        </ContentBlock>
      </section>
    </div>
  );
};

export default dmvMeet;
